export default "__VITE_ASSET__f7PZPc27__"